






























































































































































































































































































































import {
  NumberInputType,
  EPricingTableColumn,
  PricingTableHelper,
  getRowDescriptionValue,
  getRowDiscountFlatFee,
  getRowDiscountValue,
  getRowDiscountValueIsEmpty,
  getRowFormattedDiscount,
  getRowNameValue,
  getRowNetPrice,
  getRowOptionalProductField,
  getRowPriceAfterDiscounts,
  getRowSkuValue,
  getRowTaxFlatFee,
  getRowTaxValue,
  getRowTaxValueIsEmpty,
  getRowTotalPrice,
  getRowValues,
  getRowVariableQuantityEnabled,
  getRowVariableQuantityField,
  getRowOptionalProductEnabled,
  getFilteredRowValues,
  getRowFormattedTax,
  getRowDescriptionIsEmpty,
  getRowSkuValueIsEmpty,
  getRowDiscountEnabled,
  getNumberInputType,
  hasDiscount,
  Context,
  getTotalPriceEnabled,
} from '@getaccept/editor-lib';
import { PricingTableCheckbox } from '@getaccept/editor-lib/src/components/pricing-table';
import debounce from 'debounce';
import { SigningHelper } from '@getaccept/lib-shared/src/signature/helpers/signing.helper';
import type {
  PricingTableRow as IPricingTableRow,
  Field,
  PricingTableColumn,
  MergeValues,
  PricingTableCurrencySettings,
} from '@getaccept/editor-lib';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import type { RecipientStatus } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-status';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { PropType, Ref } from '@vue/composition-api';
import { onMounted, watch, computed, ref, defineComponent } from '@vue/composition-api';
import PricingTableUnitsModifierMenu from './PricingTableUnitsModifierMenu.vue';
import PricingTableDescriptionInput from './PricingTableDescriptionInput.vue';

export default defineComponent({
  name: 'PricingTableRow',
  components: {
    PricingTableDescriptionInput,
    PricingTableCheckbox,
    PricingTableUnitsModifierMenu,
  },
  props: {
    row: { type: Object as PropType<IPricingTableRow>, default: () => ({}) },
    columns: { type: Array as PropType<PricingTableColumn[]>, default: () => [] },
    isBlockWidthSmall: { type: Boolean },
    fields: { type: Array as PropType<Field[]>, default: () => [] },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, default: () => [] },
    recipient: {
      type: Object as PropType<Recipient & { status: RecipientStatus }>,
      default: () => ({}),
    },
    context: { type: String as PropType<Context>, default: () => Context.Document },
    currencySettings: {
      type: Object as PropType<PricingTableCurrencySettings>,
      default: () => ({}),
    },
    gridTemplateColumns: { type: String, default: '' },
    mergeValues: { type: Object as PropType<MergeValues>, default: () => ({}) },
    isPreCalculated: { type: Boolean },
  },
  setup(props, { emit }) {
    const rowVariableQuantityField: Ref<Partial<Field>> = ref({
      value: null,
    });

    const showVariableQuantityMenu = ref(false);

    const showDescription = computed(
      () => !getRowDescriptionIsEmpty(props.columns, getRowValues(props.row))
    );

    const showSku = computed(() => !getRowSkuValueIsEmpty(props.columns, getRowValues(props.row)));

    const showTotalPrice = computed(() => getTotalPriceEnabled(props.columns));

    const showDiscount = computed(
      () =>
        getRowDiscountEnabled(props.columns) &&
        !getRowDiscountValueIsEmpty(props.columns, getRowValues(props.row))
    );

    const isDocumentView = computed(() => props.context === Context.DocumentView);

    const recipientStatus = computed(() => props.recipient?.status);

    const isEditable = computed(
      () => !SigningHelper.hasRecipientSigned(recipientStatus.value) && !isDocumentView.value
    );

    const hasOptionalProductDeselected = computed(
      () => rowOptionalProductInputField()?.value === '0'
    );

    const rowOptionalProductInputField = () => {
      let field = getRowOptionalProductField(props.row, props.fields);
      if (!field) {
        return null;
      }

      field = { ...field, value: getFieldValue(field) };
      return field;
    };

    const rowVariableQuantityInputField = () => {
      let field = getRowVariableQuantityField(props.row, props.fields);
      if (!field) {
        return null;
      }

      field = { ...field, value: getFieldValue(field) };
      return field;
    };

    const getFieldValue = (input: Field) => {
      if (!input) {
        return;
      }
      const fieldValue = props.recipientInput?.find(field => field.fieldId === input.id)?.value;

      if (fieldValue) {
        return fieldValue;
      }

      return input.value;
    };

    const handleDebounceUpdateVariableQuantityField = (payload: { id: string; value: string }) => {
      emit('update-input-value', payload);
    };

    const debounceUpdate = debounce(handleDebounceUpdateVariableQuantityField, 300);

    const handleUpdateVariableQuantityField = (payload: { id: string; value: string }) => {
      rowVariableQuantityField.value.value = payload.value;
      debounceUpdate(payload);
    };

    const handleUpdateChecked = (payload: { id: string; value: string }) => {
      emit('update-input-value', payload);
    };

    const handleCloseVariableQuantityMenu = () => {
      showVariableQuantityMenu.value = false;
    };

    const formatPrice = (price: string) => {
      const value = price === '' ? '0' : price;
      return PricingTableHelper.currencyFormat(value, props.currencySettings);
    };

    const formatNumber = (inputValue: string, type: NumberInputType) => {
      const value = inputValue === '' ? '0' : inputValue;
      switch (type) {
        case NumberInputType.Number:
          return value;

        case NumberInputType.Text:
          return value;

        case NumberInputType.Percentage:
          return `${value}%`;

        case NumberInputType.Currency:
          return PricingTableHelper.currencyFormat(value, props.currencySettings);

        default:
          return value;
      }
    };

    onMounted(() => {
      rowVariableQuantityField.value = rowVariableQuantityInputField();
    });

    watch(
      () => [props.fields, props.recipientInput],
      () => {
        rowVariableQuantityField.value = rowVariableQuantityInputField();
      }
    );

    return {
      rowVariableQuantityField,
      showVariableQuantityMenu,
      hasRecipientSigned: SigningHelper.hasRecipientSigned,
      getColumnDisplayName: PricingTableHelper.getColumnDisplayName,
      getColumnIdFromName: PricingTableHelper.getColumnIdFromName,
      currencyFormat: PricingTableHelper.currencyFormat,
      debounceUpdate,
      showDescription,
      showSku,
      showDiscount,
      isDocumentView,
      recipientStatus,
      isEditable,
      hasOptionalProductDeselected,
      rowOptionalProductInputField,
      rowVariableQuantityInputField,
      getFieldValue,
      handleUpdateVariableQuantityField,
      handleDebounceUpdateVariableQuantityField,
      handleUpdateChecked,
      handleCloseVariableQuantityMenu,
      formatPrice,
      formatNumber,
      NumberInputType,
      getRowOptionalProductEnabled,
      getRowOptionalProductField,
      getRowDescriptionValue,
      getRowValues,
      EPricingTableColumn,
      getRowSkuValue,
      getFilteredRowValues,
      getRowVariableQuantityEnabled,
      getRowTaxValue,
      getRowTaxValueIsEmpty,
      getRowTaxFlatFee,
      getRowDiscountValueIsEmpty,
      getRowPriceAfterDiscounts,
      getRowTotalPrice,
      getRowFormattedDiscount,
      getRowFormattedTax,
      getRowNetPrice,
      getRowNameValue,
      getNumberInputType,
      getRowDiscountValue,
      getRowDiscountFlatFee,
      getRowVariableQuantityField,
      hasDiscount,
      showTotalPrice,
    };
  },
});
